import router from '@/router'
import store from '@/store/index'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { TOKEN, ROLES } from '@/store/mutation-types'
import Vue from 'vue'
import setting from '@/core/setting'
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach((to: any, from: any, next: any) => {
	NProgress.start() // start progress bar

	if (to.query.token) {
		// 为了对接用的,但重定向能set-cookie,暂时用不上
		Cookies.set(TOKEN, to.query.token)
	}

	if (to.meta.auth === false) {
		next()
		NProgress.done()
	} else {
		if (store.getters.roles.length === 0) {
			store
				.dispatch('user/GetInfo')
				.then(async roles => {
					if (roles && roles.menuPermissions.length) {
						const userInfo = store.getters.userInfo
						if (!userInfo || Object.keys(userInfo).length === 0) {
							// 用于对接 获取用户信息
							// 需要放在setting调用前 setting会从缓存中取用户信息
							await store.dispatch('user/getUserInfo')
						}
						await setting()
					}
					store.dispatch('permission/GenerateRoutes', { roles }).then(() => {
						const redirect = decodeURIComponent(from.query.redirect || to.path)
						router.addRoutes(store.getters.addRouters)
						if (to.path === redirect) {
							// hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
							next({ ...to, replace: true })
						} else {
							// 跳转到目的路由
							next({ path: redirect })
						}
					})
				})
				.catch(e => {
					router.replace('/passport/login')
				})
		} else {
			next()
		}
	}
})

router.afterEach(() => {
	NProgress.done()
	// finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
/* tslint:disable */
// const action = Vue.directive('action', {
// 	bind: function(el: any, binding: any, vnode: any) {
// 		const actionName = binding.arg
// 		const roles = store.getters.roles
// 		const elVal = vnode.context.$route.meta.permission
// 		const permissionId = (elVal instanceof String && [elVal]) || elVal
// 		roles.permissions.forEach((p: any) => {
// 			if (!permissionId.includes(p.permissionId)) {
// 				return
// 			}
// 			if (p.actionList && !p.actionList.includes(actionName)) {
// 				;(el.parentNode && el.parentNode.removeChild(el)) ||
// 					(el.style.display = 'none')
// 			}
// 		})
// 	},
// })
//
// export { action }
